import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Avatar from 'flarum/common/components/Avatar';
import username from 'flarum/common/helpers/username';
import humanTime from 'flarum/common/helpers/humanTime';
import { truncate } from 'flarum/common/utils/string';
import Link from 'flarum/common/components/Link';
import UserCard from 'flarum/forum/components/UserCard';
import ItemList from 'flarum/common/utils/ItemList';
import extractText from 'flarum/common/utils/extractText';
export default class LastDiscussionWidget extends Component {
  constructor() {
    super(...arguments);
    /**
     * Whether or not the user hover card is visible.
     */
    _defineProperty(this, "cardVisible", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.cardVisible = false;
  }
  view() {
    var _discussion$lastPostN;
    const discussion = this.attrs.discussion;
    if (!discussion) {
      return m("div", {
        class: "LastDiscussion"
      }, app.translator.trans('fof-categories.forum.last_discussion_widget.no_discussions'));
    }
    const user = discussion.lastPostedUser();
    return m(Link, {
      class: "LastDiscussion",
      href: app.route.discussion(discussion, (_discussion$lastPostN = discussion.lastPostNumber()) != null ? _discussion$lastPostN : 0)
    }, this.content().toArray());
  }
  content() {
    const items = new ItemList();
    const discussion = this.attrs.discussion;
    const user = discussion.lastPostedUser();
    items.add('avatar', m(Link, {
      className: "LastDiscussion-avatar",
      href: user ? app.route.user(user) : '#',
      "aria-label": extractText(username(user))
    }, !!user && m(Avatar, {
      user: user
    })), 100);
    items.add('mainContent', m("div", {
      class: "LastDiscussion-content"
    }, m("div", {
      class: "LastDiscussion-bottomRow"
    }, humanTime(discussion.lastPostedAt()), ' ', m(Link, {
      className: "LastDiscussion-usernameLink",
      href: user ? app.route.user(user) : '#'
    }, m("span", {
      style: {
        display: 'inline',
        margin: '0 4px'
      },
      role: "presentation"
    }, "|"), username(user))), m("div", {
      class: "LastDiscussion-topRow"
    }, truncate(discussion.title(), 26))), 50);
    let card = null;
    if (user && this.cardVisible) {
      card = UserCard.component({
        user,
        className: 'UserCard--popover',
        controlsButtonClassName: 'Button Button--icon Button--flat'
      });
    }
    items.add('card', m("div", {
      class: "LastDiscussion-userCardContainer"
    }, card), 10);
    return items;
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    let timeout;
    this.$().on('mouseover', '.LastDiscussion-avatar, .LastDiscussion-usernameLinkUserCard, .username, .UserCard', () => {
      clearTimeout(timeout);
      timeout = window.setTimeout(this.showCard.bind(this), 300);
    }).on('mouseout', '.LastDiscussion-avatar, .LastDiscussion-usernameLinkUserCard, .username, .UserCard', () => {
      clearTimeout(timeout);
      timeout = window.setTimeout(this.hideCard.bind(this), 150);
    });
  }
  onremove(vnode) {
    super.onremove(vnode);
    this.$().off('mouseover mouseout');
  }

  /**
   * Show the user card.
   */
  showCard() {
    this.cardVisible = true;
    m.redraw();
    setTimeout(() => this.$('.UserCard').addClass('in'));
  }

  /**
   * Hide the user card.
   */
  hideCard() {
    $('.UserCard').removeClass('in');
    this.cardVisible = false;
    m.redraw();
  }
}
flarum.reg.add('fof-categories', 'forum/components/LastDiscussionWidget', LastDiscussionWidget);